import { render, staticRenderFns } from "./NodeRedIntegration.vue?vue&type=template&id=64470294&scoped=true&"
import script from "./NodeRedIntegration.vue?vue&type=script&lang=ts&"
export * from "./NodeRedIntegration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64470294",
  null
  
)

export default component.exports